import { kebabCase, size, some } from 'lodash-es';

const getUserSlug = (user, currentUser) => {
  if (currentUser && currentUser.id === user.id) {
    return 'profile/me';
  } else if (user.profileVisible && user.profileUrl) {
    return `profile/${user.profileUrl}`;
  } else if (currentUser && size(user.communities) > 0) {
    // check if user belongs to same commmunity as the user's active community
    const hasMatchingCommunity = hasOverlappingCommunity(user, currentUser);

    if (hasMatchingCommunity) {
      const fullName = `${user.first_name} ${user.last_name}`;
      return `profile/${kebabCase(fullName)}-${user.id}`;
    }
  }
  return undefined;
};

const hasOverlappingCommunity = (user, requestingUser) => {
  if (requestingUser && requestingUser.id !== user.id) {
    return requestingUser.communities.some((c) => {
      return some(user.communities, (uc) => uc.communityId === c.communityId);
    });
  }
  return false;
};

const getUserCountry = (user) => {
  if (user?.location?.country) return user.location.country;
  if (user?.address?.country) return user.address.country;
  return 'US';
};

const getUserCurrency = (user) => {
  if (user?.location?.currency) return user.location.currency;
  if (user?.address?.currency) return user.address.currency;
  return 'USD';
};

const getJobTitle = ({ designation, companyName }) => {
  if (designation && companyName) {
    return `${designation} - ${companyName}`;
  }
  if (designation) {
    return designation;
  }
  return '';
};

export {
  getUserSlug,
  hasOverlappingCommunity,
  getUserCountry,
  getUserCurrency,
  getJobTitle,
};
